module.exports = __webpack_public_path__ + "static/media/plus.7b21eb4f.svg";